import { ReactElement } from "react";
import { ChatEvent as PasteChatEvent } from "@twilio-paste/core/chat-log";
import { copy, AgentEventMessageProps } from "../../definitions";
import { AgentActions } from "../../../../services/conversations/definitions/constants";

/**
 * Chat Events are for things that can happen during the chat(joining, leaving, or transferring).
 *   - Serves only as sub-component of <ChatLog />. Feel free to add more event types as neccessary.
 */
const AgentEventMessage = ({
  name = "",
  action,
}: AgentEventMessageProps): ReactElement => {
  const participantEventCopy =
    action === AgentActions.Join
      ? copy.event.agent.join(name)
      : copy.event.agent.leave(name);

  return <PasteChatEvent>{participantEventCopy}</PasteChatEvent>;
};

export default AgentEventMessage;
